// extracted by mini-css-extract-plugin
export default {"productDescription":"Ada-z","featuredDescription":"Bda-z","description":"Cda-z","more":"Dda-z","descriptionSku":"Eda-z"};